"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Native overflow scroll container. Put height / max-height on this element
 * so scrolling works — a nested `h-full` viewport under `max-h-*` +
 * `overflow-hidden` clips content without a scrollbar.
 */
const ScrollArea = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div">
>(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "relative overflow-auto rounded-[inherit]",
      "[&::-webkit-scrollbar]:w-2.5",
      "[&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-border",
      "[&::-webkit-scrollbar-track]:bg-transparent",
      className,
    )}
    {...props}
  >
    {children}
  </div>
));
ScrollArea.displayName = "ScrollArea";

const ScrollBar = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div"> & {
    orientation?: "vertical" | "horizontal";
  }
>(({ orientation: _orientation = "vertical", ..._props }, _ref) => {
  // Native overflow scrolling renders the scrollbar; kept for API compatibility.
  return null;
});
ScrollBar.displayName = "ScrollBar";

export { ScrollArea, ScrollBar };
